import gql from 'graphql-tag'

export const GET_SKILLS_TUTOR_PRODUCTS = gql`
  query {
    getSkillsTutorProducts {
      ProductInfo {
        SkillsTutorContent
        ProductId
        Name
        LPId
        LevelRange
        Description
      }
    }
  }
`
